import content from './strapi-content.json';

// Preserve the Axios/Strapi response shape consumed by the existing components.
// Clone each response so components cannot mutate the shared content file.
export async function getLocalContent(collection) {
    if (!Object.prototype.hasOwnProperty.call(content, collection)) {
        throw new Error(`Unknown local content collection: ${collection}`);
    }
    return { data: JSON.parse(JSON.stringify(content[collection])) };
}
